module.exports = __webpack_public_path__ + "img/37829-021.5c9c54da.jpg";